import { graphql } from '@teachino/shared-infrastructure';

export const updateTopicInstanceMutation = graphql(`
  mutation UpdateTopicInstance(
    $updateTopicInstanceInput: UpdateTopicInstanceInput!
  ) {
    updateTopicInstance(updateTopicInstanceInput: $updateTopicInstanceInput) {
      topicInstance {
        id
        startDate
        endDate
      }
    }
  }
`);
